import CalculateIcon from '@mui/icons-material/Calculate';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { publicColors, publicContainerSx, publicSectionSx } from './publicTheme';

const CalculatorTeaser = () => (
    <Box
        id="calculadora"
        component="section"
        sx={{
            ...publicSectionSx,
            bgcolor: publicColors.primarySoft,
            borderTop: `1px solid ${publicColors.border}`,
            borderBottom: `1px solid ${publicColors.border}`,
        }}
    >
        <Box sx={publicContainerSx}>
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
                spacing={3}
            >
                <Stack direction="row" spacing={2} alignItems="flex-start">
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: 2,
                            bgcolor: publicColors.surface,
                            border: `1px solid ${publicColors.border}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <CalculateIcon sx={{ fontSize: 32, color: publicColors.primary }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: publicColors.ink, mb: 1 }}>
                            Calculadora de preço - sem cadastro, sem pagar nada!
                        </Typography>
                        <Typography sx={{ color: publicColors.inkMuted, lineHeight: 1.65, maxWidth: 560 }}>
                            Antes de fechar um pedido, simule material, energia e descubra sua margem de forma simples. 
                            Sem planilhas complicadas, sem fórmulas intermináveis, sem necessidade de contratar um plano 
                            para algo tão simples: Você só quer saber o quanto cobrar, em segundos, na palma da sua mão!
                        </Typography>
                    </Box>
                </Stack>
                <Button
                    variant="contained"
                    size="large"
                    component={RouterLink}
                    to="/calculator"
                    sx={{
                        bgcolor: publicColors.primary,
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        boxShadow: 'none',
                        '&:hover': { bgcolor: publicColors.primaryDark, boxShadow: 'none' },
                    }}
                >
                    Abrir calculadora
                </Button>
            </Stack>
        </Box>
    </Box>
);

export default CalculatorTeaser;
